
    import { Component, Mixins } from 'vue-property-decorator';
    import { digits, separated } from '@nodes/helpers/number';
    import { YPanel, YImage, YIcon } from '@components/index';
    import Sidebar from '@rogues/Sidebar/shared/sidebar';

    @Component({
        components: {
            YPanel,
            YImage,
            YIcon,
        },
    })
    /**
     * @name Dashboard
     */
    export default class Dashboard extends Mixins(Sidebar) {
        digits = digits;
        separated = separated;

        /**
         * Get User Avatar
         * 
         * @returns {object}
         */
        get avatar(): object {
            let img = null;
            if (this.user && this.user.avatar && this.user.avatar.length) {
                [img] = this.userMetadata.avatar.resource;
            }
            return img;
        }

        /**
         * User Contact info to Show
         * At the bottom of the user name
         * 
         * @returns {string}
         */
        get userContactInfo(): string {
            let contact = null;
            if (this.userContactToShow === 'mobile') {
                if (this.user.mobile && this.user.mobile.country_code) {
                    contact = `${this.user.mobile?.country_code}${this.user.mobile?.mobile}`;
                } else {
                    contact = this.user.mobile?.mobile;
                }
            } else {
                contact = this.user[this.userContactToShow];
            }
            return this.digits(contact, this.$i18n.locale);
        }

        /**
         * Check the Active Route
         *
         * @param {string} slug
         * @returns {boolean}
         */
        activeRoute(slug: string): boolean {
            return this.$route.name.includes(slug);
        }
    }
